import {ACTION_TYPES} from 'constants/ActionTypes';

export function addShoppingCart(id) {
  return dispatch => {
    dispatch({
      type: ACTION_TYPES.ADD_SHOPPING_CARD,
      data: id
    });
  };
}

export function removeShoppingCart(id) {
  return dispatch => {
    dispatch({
      type: ACTION_TYPES.REMOVE_SHOPPING_CARD,
      data: id
    });
  };
}

export function cleanShoppingCart() {
  return dispatch => {
    dispatch({
      type: ACTION_TYPES.CLEAN_SHOPPING_CARD
    });
  };
}



// WEBPACK FOOTER //
// ./actions/shopping-cart.js